import React from 'react';
import Tooltip from '../Tooltip';
import DiameterSelector from './DiameterSelector';

const FixationsSelector = ({
  fixationHaute,
  setFixationHaute,
  fixationBasse,
  setFixationBasse,
  diametreJoncHaute,
  setDiametreJoncHaute,
  diametreJoncBasse,
  setDiametreJoncBasse,
  diametreFourreauBasse,
  setDiametreFourreauBasse,
  joncMedianPosition,
  setJoncMedianPosition,
  fixationsHaute,
  fixationsBasse,
  isStoreDroit
}) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-3">Comment fixez-vous votre toile ?</h3>
      
      {/* Fixation haute */}
      <div className="mb-6">
        <label className="block text-sm font-medium mb-3 flex items-center gap-2">
          Fixation haute
          <Tooltip tooltipKey="fixation-haute" size={14} />
        </label>
        <div className="grid grid-cols-4 gap-3">
          {fixationsHaute.map((fixation) => (
            <button
              key={fixation.id}
              onClick={() => setFixationHaute(fixation.id)}
              className={`p-3 border-2 rounded-lg text-center transition-all ${
                fixationHaute === fixation.id
                  ? 'border-celadon bg-celadon text-white'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              {fixation.image ? (
                <img 
                  src={fixation.image} 
                  alt={fixation.label}
                  className="w-16 h-16 mx-auto mb-2 object-contain"
                />
              ) : (
                <div className="w-16 h-16 mx-auto mb-2 flex items-center justify-center text-3xl text-gray-400">
                  📐
                </div>
              )}
              <p className="text-xs font-medium">{fixation.label}</p>
            </button>
          ))}
        </div>
        
        {/* Sélecteur de diamètre du jonc haute */}
        {fixationHaute === 'jonc' && (
          <DiameterSelector
            type="jonc"
            value={diametreJoncHaute}
            onChange={setDiametreJoncHaute}
            options={[3, 4, 5, 5.5, 6, 7, 8]}
          />
        )}
        
        {/* Question sur la position du jonc médian */}
        {!isStoreDroit && (
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm font-medium mb-3">Le jonc médian est-il SUR la toile ou bien SOUS la toile ?</p>
            <div className="flex gap-3">
              <button
                onClick={() => setJoncMedianPosition('sur')}
                className={`flex-1 px-4 py-3 border-2 rounded-lg font-medium transition-all ${
                  joncMedianPosition === 'sur'
                    ? 'border-celadon bg-celadon text-white'
                    : 'border-gray-300 hover:border-gray-400 bg-white'
                }`}
              >
                SUR la toile
              </button>
              <button
                onClick={() => setJoncMedianPosition('sous')}
                className={`flex-1 px-4 py-3 border-2 rounded-lg font-medium transition-all ${
                  joncMedianPosition === 'sous'
                    ? 'border-celadon bg-celadon text-white'
                    : 'border-gray-300 hover:border-gray-400 bg-white'
                }`}
              >
                SOUS la toile
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Fixation basse */}
      <div className="mb-6">
        <label className="block text-sm font-medium mb-3 flex items-center gap-2">
          Fixation basse
          <Tooltip tooltipKey="fixation-basse" size={14} />
        </label>
        <div className="grid grid-cols-4 gap-3">
          {fixationsBasse.map((fixation) => (
            <button
              key={fixation.id}
              onClick={() => setFixationBasse(fixation.id)}
              className={`p-3 border-2 rounded-lg text-center transition-all ${
                fixationBasse === fixation.id
                  ? 'border-celadon bg-celadon text-white'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              {fixation.image ? (
                <img 
                  src={fixation.image} 
                  alt={fixation.label}
                  className="w-16 h-16 mx-auto mb-2 object-contain"
                />
              ) : (
                <div className="w-16 h-16 mx-auto mb-2 flex items-center justify-center text-3xl text-gray-400">
                  📐
                </div>
              )}
              <p className="text-xs font-medium">{fixation.label}</p>
            </button>
          ))}
        </div>
        
        {/* Sélecteur de diamètre du jonc basse */}
        {fixationBasse === 'jonc' && (
          <DiameterSelector
            type="jonc"
            value={diametreJoncBasse}
            onChange={setDiametreJoncBasse}
            options={[3, 4, 5, 5.5, 6, 7, 8]}
          />
        )}
        
        {/* Sélecteur de diamètre du fourreau basse */}
        {fixationBasse === 'fourreau' && (
          <DiameterSelector
            type="fourreau"
            value={diametreFourreauBasse}
            onChange={setDiametreFourreauBasse}
            options={[18, 20, 25, 30, 35, 40, 45, 50]}
          />
        )}
      </div>
    </div>
  );
};

export default FixationsSelector;